const DEFAULT_LIMIT = 50;
const PAGE_SIZES = new Set([25, 50, 100, 200]);
const UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
export function isDeletionFailureUuid(value) {
    return typeof value === 'string' && UUID_PATTERN.test(value);
}
function readOffset(value) {
    if (value == null || value.trim() === '')
        return 0;
    const parsed = Number(value);
    return Number.isInteger(parsed) && parsed >= 0 ? parsed : 0;
}
function readLimit(value) {
    if (value == null || value.trim() === '')
        return DEFAULT_LIMIT;
    const parsed = Number(value);
    return Number.isInteger(parsed) && PAGE_SIZES.has(parsed) ? parsed : DEFAULT_LIMIT;
}
export function readDeletionFailureUrl(params) {
    const rawSelection = params.get('failure_id');
    return {
        filters: {
            status: params.get('status')?.trim() || undefined,
            participant: params.get('participant')?.trim() || undefined,
            kind: params.get('kind')?.trim() || undefined,
            limit: readLimit(params.get('limit')),
            offset: readOffset(params.get('offset')),
        },
        selectedFailureId: isDeletionFailureUuid(rawSelection) ? rawSelection.toLowerCase() : null,
        selectionError: rawSelection != null && rawSelection !== '' && !isDeletionFailureUuid(rawSelection),
    };
}
const FILTER_PARAMS = {
    status: 'status',
    participant: 'participant',
    kind: 'kind',
    limit: 'limit',
    offset: 'offset',
};
export function writeDeletionFailureUrl(current, patch) {
    const next = new URLSearchParams(current);
    if ('selectedFailureId' in patch) {
        if (patch.selectedFailureId)
            next.set('failure_id', patch.selectedFailureId.toLowerCase());
        else
            next.delete('failure_id');
    }
    if (patch.filters) {
        let resetOffset = false;
        for (const [key, value] of Object.entries(patch.filters)) {
            const param = FILTER_PARAMS[key];
            if (value == null || value === '')
                next.delete(param);
            else
                next.set(param, String(value));
            if (key !== 'offset')
                resetOffset = true;
        }
        if (resetOffset && patch.filters.offset === undefined)
            next.set('offset', '0');
    }
    return next;
}
